import React from 'react';
import { Header } from './styles';

interface AiManagementModalHeaderProps {
  title: string;
  onClose: () => void;
}

const AiManagementModalHeader: React.FC<AiManagementModalHeaderProps> = ({ title, onClose }) => (
  <Header className="d-flex align-items-center justify-content-between px-4 py-3 flex-shrink-0">
    <h5 className="mb-0 font-weight-bold">{title}</h5>
    <button
      type="button"
      className="btn btn-link p-0 text-white d-flex align-items-center"
      aria-label="Fechar"
      onClick={onClose}
    >
      <i className="material-icons">close</i>
    </button>
  </Header>
);

export default AiManagementModalHeader;
